import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { LoginRequest, LoginResponse } from "../models/account/login.model";
import { ConfirmEmailRequest } from "../models/account/confirm-email.model";
import { RegisterRequest } from "../models/account/register.model";
import { RefreshTokenRequest } from "../models/account/refresh-token.model";
import { ClientResponse } from "../models/api-response.model";
import { BaseService } from "./base.service";

@Injectable({ providedIn: "root" })
export class AccountService extends BaseService {
  login(request: LoginRequest): Observable<ClientResponse<LoginResponse>> {
    return this.post<LoginResponse>("/api/v1/account/login", request);
  }

  register(request: RegisterRequest): Observable<ClientResponse<void>> {
    return this.post<void>("/api/v1/account/register", request);
  }

  confirmEmail(request: ConfirmEmailRequest): Observable<ClientResponse<void>> {
    return this.post<void>("/api/v1/account/confirm-email", request);
  }

  refreshToken(request: RefreshTokenRequest): Observable<ClientResponse<LoginResponse>> {
    return this.post<LoginResponse>("/api/v1/account/refresh-token", request);
  }
}
